<template>
  <figure
    class="kvass-media-render-image"
    :class="`kvass-media-render-image--caption-${captionPlacement} kvass-media-render-image--caption-${captionVisibility}`"
  >
    <img
      :src="value.url"
      :style="`object-fit: ${size}`"
      :alt="value.name"
      v-bind="$attrs"
      v-on="$listeners"
      class="kvass-media-render-image__image"
    />
    <figcaption v-if="value.description" class="kvass-media-render-image__caption">
      {{ value.description }}
    </figcaption>
  </figure>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
    },
    size: {
      type: String,
      default: 'cover',
    },
    captionPlacement: {
      type: String,
      default: 'inside',
      validator(val) {
        return ['inside', 'outside'].includes(val)
      },
    },
    captionVisibility: {
      type: String,
      default: 'hover',
      validator(val) {
        return ['hover', 'visible', 'hidden'].includes(val)
      },
    },
  },
}
</script>

<style lang="scss">
.kvass-media-render-image {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;

  &__image {
    height: 100%;
    width: 100%;
  }

  &__caption {
    line-height: 1.5;
  }

  &--caption {
    &-inside {
      .kvass-media-render-image__caption {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 0.8rem 1rem;
        background: linear-gradient(to bottom, transparent, rgba(black, 0.6));
        color: white;
        transition: opacity 200ms ease-out;
        pointer-events: none;
      }

      &.kvass-media-render-image--caption-hidden {
        .kvass-media-render-image__caption {
          opacity: 0 !important;
        }
      }

      &.kvass-media-render-image--caption-visible {
        .kvass-media-render-image__caption {
          opacity: 1;
        }
      }

      &.kvass-media-render-image--caption-hover {
        @media (hover: hover) {
          .kvass-media-render-image__caption {
            opacity: 0;
          }

          &:hover {
            .kvass-media-render-image__caption {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>
